import { FilterOperator } from "../../helpers/enums";
import { IFilter } from "../../helpers/filtrable";

export class SearchColumn implements IFilter {
  PropertyName: string;
  Operator: FilterOperator;
  Value: any;
  DisplayName: string;
  Style: any;
  Class: string;
  Hidden = false;
  MapPropertyName: string;

  constructor(
    propertyName?: string,
    displayName?: string,
    operator?: FilterOperator
  ) {
    this.PropertyName = propertyName;
    this.DisplayName = displayName;

    this.Operator = operator || FilterOperator.Equals;
    this.SetMapPropertyName(this.PropertyName);
  }

  ToFilter(): IFilter {
    return {
      PropertyName: this.PropertyName,
      Operator: this.Operator,
      Value: this.Value
    };
  }

  SetStyle(style: any): SearchColumn {
    this.Style = style;

    return this;
  }

  SetHidden(hidden: boolean): SearchColumn {
    this.Hidden = hidden;

    return this;
  }

  SetClass(_class: string): SearchColumn {
    this.Class = _class;

    return this;
  }

  SetMapPropertyName(mapPropertyName: string): SearchColumn {
    this.MapPropertyName = mapPropertyName;

    return this;
  }
}

export interface SearchDirective {
  showModal();
  search();
  select(model: any);
}
